export const DEFAULT_MARKER_COLOR = "var(--surface-warning-solid-color)";
